import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

// three.js and its GLTF loader emit informational console.log lines (e.g. one
// 'Duplicating UVs to support aoMap' per mesh in the cube). Keep them in
// development, drop them from the production console.
if (process.env.NODE_ENV === 'production') {
  const log = console.log.bind(console);
  console.log = (...args) => {
    if (typeof args[0] === 'string' && args[0].startsWith('THREE.')) return;
    log(...args);
  };
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
